/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum InsuranceAutocompleteModalAliases {
  AUTOCOMPLETE_CATEGORY = 'autocomplete-category',
  AUTOCOMPLETE_HEALTH = 'autocomplete-health',
  AUTOCOMPLETE_PLAN = 'autocomplete-plan',
  CHECKBOX_SAVE_INSURANCE = 'checkbox-save-insurance',
  DATE_FIELD_0 = 'date-field-0',
  FETCH_CATEGORY = 'fetch-category',
  FETCH_HEALTH = 'fetch-health',
  FETCH_PLAN = 'fetch-plan',
  FIELD_CATEGORY = 'field-category',
  FIELD_CHECKBOX_SAVE_INSURANCE = 'field-checkbox-save-insurance',
  FIELD_HEALTH = 'field-health',
  FIELD_HEALTH_CARD_NUMBER = 'field-health-card-number',
  FIELD_PLAN = 'field-plan',
  FIELD_WALLET_EXIPRY = 'field-wallet-exipry',
  FORM_INSURANCE = 'form-insurance',
  INPUT_0 = 'input-0',
  LAYOUT_INSURANCES = 'layout-insurances',
  MAPPER_CATEGORY = 'mapper-category',
  MAPPER_HEALTH = 'mapper-health',
  MAPPER_PLAN = 'mapper-plan',
  PANEL_INSURANCE = 'panel-insurance',
  TEXT_CATEGORY = 'text-category',
  TEXT_HEALTH = 'text-health',
  TEXT_PLAN = 'text-plan',
}
export { InsuranceAutocompleteModalAliases };
